import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { noop } from 'ts-essentials';
import { HeatingCircuitProvider } from './provider';
import { HeatingCircuitCard } from './variants';
export const HeatingCircuitView = memo(function HeatingCircuitView(props) {
    const { config, children, onClick = noop, lazy } = props;
    return (_jsx(HeatingCircuitProvider, { config: config, lazy: lazy, children: children ? children : _jsx(HeatingCircuitCard, { onClick: onClick }) }));
});
